import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  Observable,
} from '@apollo/client';

import { GRAPHQL_ENDPOINT } from '../config';

export default ({ accessToken, signalLogout }) => {
  const httpLink = new HttpLink({
    uri: GRAPHQL_ENDPOINT,
    credentials: 'include',
  });

  const authLink = new ApolloLink((operation, forward) => {
    const context = operation.getContext();
    const token = accessToken();

    operation.setContext({
      headers: {
        ...context.headers,
        Authorization: token ? `Bearer ${token}` : '',
      },
    });

    return forward(operation);
  });

  const authFailedLink = new ApolloLink(
    (operation, forward) =>
      new Observable((observer) => {
        const subscriber = forward(operation);

        const analyzeErrors = (errors) => {
          if (errors && errors.length) {
            if (
              errors.filter(
                (error) =>
                  ['authentication_failed', 'jwt_expired'].indexOf(error.id) !==
                  -1
              ).length
            ) {
              signalLogout();
            }
          }
        };

        const subscription = subscriber.subscribe({
          next: (data) => analyzeErrors(data.errors) || observer.next(data),
          error: (error) =>
            analyzeErrors(error.graphQLErrors) || observer.error(error),
        });

        return () => {
          if (subscription) subscription.unsubscribe();
        };
      })
  );

  const apolloClient = new ApolloClient({
    cache: new InMemoryCache(),
    link: ApolloLink.from([authLink, authFailedLink, httpLink]),
  });

  return apolloClient;
};
